module.exports = __webpack_public_path__ + "img/1134637518.0800befc.jpg";